import React, { useEffect, useState } from 'react'
import { DatePicker, Select, Button, Table, Spin, Tooltip, Space, message } from 'antd'
import moment from 'moment'
import { InfoCircleOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router'

import Layout from '../../components/layout/Layout'
import axiosInstance from '../../utils/axiosInstance'

const { RangePicker, Avatar } = DatePicker

const timeZones = [
  {
    value: '-5',
    label: '-5',
  },
  {
    value: '-6',
    label: '-6',
  },
  {
    value: '+5',
    label: '+5',
  },
  {
    value: '+6',
    label: '+6',
  },
]
const renderSection = (title, description, items = []) => ({
  title,
  content: (
    <div style={{ margin: 0 }}>
      {description}
      <ul style={{ paddingLeft: 16, margin: 0 }}>
        {items.length > 0 ? (
          items.map((item) => (
            <li key={item._id}>
              {item.subTitle} — <strong>{item.completedCount} reps</strong> · <strong>{item.completionPercentage}%</strong>
            </li>
          ))
        ) : (
          <li>No activities added yet by admin to evaluate</li>
        )}
      </ul>

      {/* Total reps */}
      {items.length > 0 && (
        <p
          style={{
            marginTop: 6,
            color: 'green',
          }}
        >
          Total reps: {items.reduce((sum, activity) => sum + (activity.completedCount || 0), 0)}
        </p>
      )}
    </div>
  ),
})

function LeadershipTrack() {
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const [organizations, setOrganizations] = useState([])
  const [selectedOrg, setSelectedOrg] = useState('')
  const [orgMembers, setoOrgMembers] = useState([])
  const [selectedMember, setSelectedMember] = useState('')
  const [data, setData] = useState(null)
  const [calculations, setCalculations] = useState(null)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [timeZone, setTimeZone] = useState(timeZones[0].value)

  const getMyInfo = async () => {
    try {
      setLoading(true)

      const response = await axiosInstance.get(`/api/v1/admin/me`)

      // Check the admin organizations
      if (response?.data?.user?.organizations && response?.data?.user?.organizations.length > 0) {
        const org = response.data.user.organizations
        // console.log(org)

        // store to render at JSX
        org.forEach((element, idx) => {
          if (idx == 0) setSelectedOrg(element._id) // auto selecting the first organization to fetch some results
          setOrganizations((prevElements) => [
            ...prevElements,
            {
              value: element._id,
              label: element.name,
            },
          ])
        })
      }

      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const getData = async (id) => {
    try {
      // console.log(id)

      if (!startDate || !endDate) {
        console.log(startDate, endDate)
        message.error('Please properly add start & end date!')
        return
      }

      if (!id) {
        message.info('Getting results only for club, because no specific person was selected.')
      } else {
        message.info('Getting results only for specific person. Because an user was selected.')
      }

      setLoading(true)

      const payload = {
        timeZone,
        startDate,
        endDate,
        summaryOfClub: selectedOrg,
        userId: id,
      }

      // console.log(payload)

      const response = await axiosInstance.post(`/api/v1/metrics/leadershipTrack`, payload)

      console.log(response.data)

      setData(response.data.mainData)

      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const getAClubMembers = async (id) => {
    try {
      setLoading(true)

      setoOrgMembers([])

      const response = await axiosInstance.get(`/api/v1/admin/getAClubMembers?clubId=${id}`)

      response.data.users.forEach((element) => {
        setoOrgMembers((prevElements) => [
          ...prevElements,
          {
            value: element._id,
            label: element.firstName + ' ' + element.lastName,
          },
        ])
      })

      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const handleRangePicker = (value) => {
    // console.log('Selected Time: ', value)
    value?.map((el, idx) => {
      // console.log(moment(new Date(el)).format('MMMM DD, YYYY h:mm:ss a')) // Readable format
      // console.log(new Date(el).getTime()) // Epoch timestamp in miliseconds
      let start = 0
      let end = 0
      if (idx == 0) {
        start = new Date(el).getTime()
        setStartDate(start)
      } else if (idx == 1) {
        end = new Date(el).getTime()
        setEndDate(end)
      }
      console.log(start)
      console.log(end)
    })
  }

  useEffect(() => {
    getMyInfo()
  }, [])

  useEffect(() => {
    if (selectedOrg) {
      getAClubMembers(selectedOrg)
    }
  }, [selectedOrg])

  useEffect(() => {
    // console.log('selectedMember')
    // console.log(selectedMember)
    if (selectedMember) {
      if (selectedMember) {
        getData(selectedMember)
      }
    }
  }, [selectedMember])

  if (organizations.length == 0) return null

  return (
    <Layout>
      <h1>Leadership Track</h1>

      <Space>
        <Select
          placeholder="Please select club or business"
          style={{ width: 250 }}
          defaultValue={organizations[0].value}
          onChange={(value) => setSelectedOrg(value)}
          options={organizations}
        />
        <RangePicker onChange={handleRangePicker} />

        {orgMembers.length && (
          <Select
            placeholder="Select a member (Optional)"
            style={{ width: 250 }}
            onChange={(value) => {
              console.log(value)
              setSelectedMember(value)
            }}
            options={orgMembers}
            showSearch
            filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
            allowClear
          />
        )}
        <Select placeholder="Please select timezone" style={{ width: 100 }} defaultValue={timeZones[0].value} onChange={(value) => setTimeZone(value)} options={timeZones} />

        <Button
          type="primary"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            getData(selectedMember)
          }}
          loading={loading}
        >
          Get data
        </Button>
      </Space>

      <br />
      <br />

      <Button
        type="default"
        style={{ cursor: 'pointer' }}
        onClick={() => {
          navigate('/metrics/leadershipTrack/modifyActivities')
        }}
        loading={loading}
      >
        Modify activites on each card
      </Button>

      <br />
      <br />
      <div style={{ marginTop: 10 }}></div>
      <p style={{ color: '#c4c4c4' }}>Please change user to get expected data.</p>

      {data && (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 16,
            justifyContent: 'flex-start',
          }}
        >
          {/* Card */}
          {[
            {
              title: <div>Consistency </div>,
              content: (
                <>
                  {data?.consistency?.activeDays?.percentage && (
                    <p style={{ margin: 0 }}>
                      <strong>{data.consistency.activeDays.percentage}%</strong> of days active in the app
                      <br />
                      in the last {data.consistency.activeDays.totalDays} days{' '}
                      <Tooltip title="Consistency is calculated as the percentage of days within the selected time range on which the user recorded at least one entry. For example, if the selected time range spans 100 days and the user added at least one entry on 90 of those days, the consistency score would be 90%. But if the completed items was not on the same day scheduled, but completed on other day then that other day will calculated as active in this. For scheduled day completed another metrics needed in this consistency, which should be below.">
                        <InfoCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                      </Tooltip>
                    </p>
                  )}
                  <br />
                  {data?.consistency?.activeDays && (
                    <p style={{ margin: 0 }}>
                      You completed <strong>{data.consistency.activeDays.totalCompletedItems}</strong> out of <strong>{data.consistency.activeDays.totalItems}</strong> items in the
                      last <strong>{data.consistency.activeDays.totalDays}</strong> days — that's{' '}
                      <strong>{Math.round((data.consistency.activeDays.totalCompletedItems / data.consistency.activeDays.totalItems) * 100)}%</strong> completion.
                    </p>
                  )}
                </>
              ),
            },
            {
              title: 'Follow-Through',
              content: (
                <div>
                  {data?.followThrough?.top5Habits && (
                    <>
                      <p
                        style={{
                          fontWeight: 'bold',
                          textDecoration: 'underline',
                          marginBottom: 0,
                        }}
                      >
                        Top habits{'  '}
                        <Tooltip title="Follow-Through top habits reflects the habits with the highest completion levels within the selected time range. For each habit, the completion percentage is calculated by comparing the number of times it was completed against the number of times it was scheduled during the selected period.This evaluation is applied across all habits collectively within the given time range. If the same habit is performed in different contexts or locations, all occurrences are aggregated and treated as a single habit for the purpose of this calculation.">
                          <InfoCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                        </Tooltip>
                      </p>

                      <ul style={{ paddingLeft: 16, margin: 0 }}>
                        {data.followThrough.top5Habits.length > 0 ? (
                          data.followThrough.top5Habits.map((habit) => (
                            <li key={habit.habitId}>
                              {habit.subTitle} — <strong>{habit.completionPercentage}%</strong>
                            </li>
                          ))
                        ) : (
                          <li style={{ color: '#999' }}>No habit data available</li>
                        )}
                      </ul>
                      {/* Total reps */}
                      {data.followThrough.top5Habits.length > 0 && (
                        <p
                          style={{
                            marginTop: 6,
                            color: 'green',
                          }}
                        >
                          Total reps: {data.followThrough.top5Habits.reduce((sum, activity) => sum + (activity.completeCount || 0), 0)}
                        </p>
                      )}
                    </>
                  )}

                  {data?.followThrough?.topCompletedActivities && (
                    <>
                      <p
                        style={{
                          fontWeight: 'bold',
                          textDecoration: 'underline',
                          marginBottom: 0,
                        }}
                      >
                        Top activities{'  '}
                        <Tooltip title="Follow-Through (Top 5 Activities) highlights the activities with the highest number of completions within the selected time range. This ranking is calculated across all activity categories, based solely on how frequently each activity was completed during the given period.">
                          <InfoCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                        </Tooltip>
                      </p>

                      <ul style={{ paddingLeft: 16, margin: 0 }}>
                        {data.followThrough.topCompletedActivities.length > 0 ? (
                          data.followThrough.topCompletedActivities.map((activity) => (
                            <li key={activity.habitId}>
                              {activity.subTitle} —{' '}
                              <strong>
                                {activity.completeCount} Reps ({activity.parent[0].title})
                              </strong>
                            </li>
                          ))
                        ) : (
                          <li style={{ color: '#999' }}>No data available</li>
                        )}
                      </ul>

                      {/* Total reps */}
                      {data.followThrough.topCompletedActivities.length > 0 && (
                        <p
                          style={{
                            marginTop: 6,
                            color: 'green',
                          }}
                        >
                          Total reps: {data.followThrough.topCompletedActivities.reduce((sum, activity) => sum + (activity.completeCount || 0), 0)}
                        </p>
                      )}
                    </>
                  )}
                </div>
              ),
            },
            {
              title: 'Sustainability',
              content: (
                <>
                  {data?.sustainability?.topCompletedActivities && (
                    <>
                      <p
                        style={{
                          fontWeight: 'bold',
                          textDecoration: 'underline',
                          marginBottom: 0,
                        }}
                      >
                        Top activities{'  '}
                        <Tooltip title="Sustainability (Top 3 Activities) highlights the activities with the highest number of completions within the selected time range. This ranking is calculated across all activity categories, based solely on how frequently each activity was completed during the given period.">
                          <InfoCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                        </Tooltip>
                      </p>

                      <ul style={{ paddingLeft: 16, margin: 0 }}>
                        {data.sustainability.topCompletedActivities.length > 0 ? (
                          data.sustainability.topCompletedActivities.map((activity) => (
                            <li key={activity.habitId}>
                              {activity.subTitle} —{' '}
                              <strong>
                                {activity.completeCount} Reps ({activity.parent[0].title})
                              </strong>
                            </li>
                          ))
                        ) : (
                          <li style={{ color: '#999' }}>No data available</li>
                        )}
                      </ul>

                      {/* Total reps */}
                      {data.sustainability.topCompletedActivities.length > 0 && (
                        <p
                          style={{
                            marginTop: 6,
                            color: 'green',
                          }}
                        >
                          Total reps: {data.sustainability.topCompletedActivities.reduce((sum, activity) => sum + (activity.completeCount || 0), 0)}
                        </p>
                      )}
                    </>
                  )}
                </>
              ),
            },
            // if not selectedMember, that means for clubs dont show these
            ...(selectedMember && Object.keys(data.restOfcards).length
              ? [
                  renderSection('Support', 'Community and reminders help consistency.', data.restOfcards.support),
                  renderSection('Connection', 'Building meaningful connections over time.', data.restOfcards.connection),
                  renderSection('Guide', 'Guiding others through intentional actions.', data.restOfcards.guide),
                  renderSection('Opportunity Creator', 'Creating opportunities through consistent effort.', data.restOfcards.opportunityCreator),
                  renderSection('Leader Developer', 'Developing leadership through action.', data.restOfcards.leaderDeveloper),
                  renderSection('Culture Builder', 'Shaping culture with repeated behaviors.', data.restOfcards.cultureBuilder),
                ]
              : []),
          ].map((card, index) => (
            <div
              key={index}
              style={{
                flex: '1 1 380px',
                maxWidth: '360px',
                backgroundColor: '#fff',
                borderRadius: 12,
                padding: 16,
                boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                color: '#000',
              }}
            >
              <h3
                style={{
                  textAlign: 'center',
                  margin: '0 0 12px 0',
                }}
              >
                {card.title}
              </h3>
              {card.content}
            </div>
          ))}
        </div>
      )}
    </Layout>
  )
}

export default LeadershipTrack
